import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgIconPlus = (props, ref) => _jsx("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "currentColor", ref: ref, ...props, children: _jsx("path", { d: "M11 17a1 1 0 1 0 2 0v-4h4a1 1 0 1 0 0-2h-4V7a1 1 0 1 0-2 0v4H7a1 1 0 1 0 0 2h4z" }) });
const ForwardRef = forwardRef(SvgIconPlus);
export default ForwardRef;
